module.exports = __webpack_public_path__ + "static/img/shifan.84e7e2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shifan.png
// module id = kODl
// module chunks = 128